import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EHouseLineType } from '../../../packages/api-models/common/json_query';

export const selectBuildingHouseLine = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('building_house_line_type__shopping_area')(jsonQuery) as EHouseLineType[] | null,
);
